<template>
	<router-link :to="link" class="sidebar-item">
		<div class="sidebar-item__icon">
			<component v-if="icon" :is="icon" />
		</div>
		<p class="sidebar-item__name">{{ name }}</p>
		<badge class="sidebar-item__badge" :value="badge" />
	</router-link>
</template>

<script>
import Badge from '@/components/Badge'

export default {
	name: 'SidebarItem',
	props: {
		name: String,
		icon: Object,
		to: null,
		badge: Number,
	},
	computed: {
		link() {
			return this.to || { name: this.name }
		},
	},
	components: {
		Badge,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.sidebar-item {
	@extend %flex-row;
	height: 3.75rem;
	text-decoration: none;
	padding: 0 1.25rem;

	&__icon {
		@include square(1.5rem);
		color: $white;
		margin-right: 0.5rem;
	}
	&__name {
		color: $white;
		flex-grow: 1;
	}
	&__badge {
		flex-shrink: 0;
	}

	&.router-link-active {
		background-color: $grey-95;
	}
	&.router-link-active &__name,
	&.router-link-active &__icon {
		color: $col-primary;
	}
}
</style>
